import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "lib/api";
import { useDashboardSettings } from "../settings/store";

const keys = {
  dashboardFotos(periodoId, nivelId) {
    return ["dashboard", "fotos", { periodoId, nivelId }];
  },
};

export function useDashboardFotos(enabled = true) {
  const s = useDashboardSettings();

  return useQuery({
    queryKey: keys.dashboardFotos(s.periodoId, s.nivelId),
    queryFn: () => api("/dashboard/club/fotos", {}, { periodoId: s.periodoId }),
    enabled: enabled && !!s.periodoId && !!s.nivelId,
    staleTime: 20_000,
  });
}

export function useSetDashboardPeriodoCover() {
  const s = useDashboardSettings();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (payload) =>
      api("/dashboard/club/fotos/periodo-cover", { method: "POST", body: JSON.stringify(payload) }, { periodoId: s.periodoId }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["dashboard", "fotos"] });
      qc.invalidateQueries({ queryKey: ["dashboard", "context"] });
      qc.invalidateQueries({ queryKey: ["main", "actividades"] });
    },
  });
}
